import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Input, Label, Icon, Form, Popup } from 'semantic-ui-react';

const inputStyle = { marginBottom: 10 };
const inputAction = { icon: 'plus' };
const validationRegex = /^([#|@|$])?[\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFFA-zÀ-úа-яА-Я.0-9]{2,}$/;
const requiredLabelStyle = { color: 'red' };
const RequiredLabel = () => (<span style={requiredLabelStyle}>*</span>);
const HelpPopup = () => <Popup
  content="enter hashtags, @mentions or any text you want to use to capture the influencer posts.
    The system will search the post or story caption and add the post to the campaign if it matches.
    Hashtags must be more than 4 characters"
  trigger={<Icon name="help circle" className="circular" />}
/>;

export default class HashtagsInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      tags: props.hashtags,
    };
  }

  onAddHashTagCallback = e => {
    e.preventDefault();
    const {
      maxTags,
      onValueChanged,
    } = this.props;
    const {
      value,
      tags,
    } = this.state;

    if (_.toNumber(maxTags) === _.size(tags)) {
      return;
    }

    const tagsClone = _.clone(tags);
    tagsClone.push(value);
    this.setState({
      tags: tagsClone,
      value: '',
    }, () => {
      onValueChanged(e, {
        name: 'hashtags',
        value: _.join(tagsClone, ','),
      });
    });
  }

  onTextInputChange = (e, { value }) => {
    this.setState({
      value: _.replace(value, /[, ]+/g, ''),
    });
  }

  onDeleteTag = tagToRemove => {
    const { tags } = this.state;
    const newTags = _.reject(tags, tag => tag === tagToRemove);
    this.setState({
      tags: newTags,
    }, () => {
      this.props.onValueChanged({}, {
        name: 'hashtags',
        value: _.join(newTags, ','),
      });
    });
  }

  render() {
    const {
      maxTags,
      campaignType,
    } = this.props;

    const {
      value,
      tags,
    } = this.state;

    const isAutomated = campaignType === 'AUTOMATED';

    const isValidInput = new RegExp(validationRegex).test(value);

    const shouldDisableAddButton = _.toNumber(maxTags) === _.size(tags);

    const actionProps = {
      onClick: this.onAddHashTagCallback,
      ...inputAction,
      disabled: shouldDisableAddButton || !isValidInput,
    };

    return (
      <Form.Field>
        {
          isAutomated &&
          <label htmlFor="campaign-hashtags">
            Tracked <i>#hashtag</i> or <i>@mention</i> (max. {maxTags})
            <RequiredLabel />  <HelpPopup />
          </label>
        }
        {
          !isAutomated &&
          <label htmlFor="campaign-hashtags">
            #Hashtags (max. {maxTags})  <HelpPopup />
          </label>
        }
        <Input
          action={actionProps}
          onChange={this.onTextInputChange}
          placeholder={shouldDisableAddButton ? 'max tags added' : 'e.g. #nike'}
          value={value}
          style={inputStyle}
          disabled={shouldDisableAddButton}
        />
        {
          _.map(tags, tag => (
            <Label image size="large" basic>
              { tag }
              <Icon name="delete" color="red" onClick={() => this.onDeleteTag(tag)} />
            </Label>
          ))
        }
      </Form.Field>
    );
  }
}

HashtagsInput.propTypes = {
  maxTags: PropTypes.number,
  hashtags: PropTypes.array,
  onValueChanged: PropTypes.func.isRequired,
  campaignType: PropTypes.string,
};

HashtagsInput.defaultProps = {
  maxTags: 10,
  hashtags: [],
  campaignType: 'MANUAL',
};



/** WEBPACK FOOTER **
 ** ./src/components/hashtags-input/index.js
 **/